//
// Copyright 2024 DXOS.org
//

import { Migration } from '@dxos/echo';

/**
 * @deprecated Import `Migration.define` from `@dxos/echo` instead.
 */
export const defineObjectMigration = Migration.define;

/**
 * @deprecated Import `Migration.ObjectMigration` from `@dxos/echo` instead.
 */
export type ObjectMigration = Migration.ObjectMigration;
